import { createContext } from "react";

interface ServerData {
  recaptchaSiteKey: string | undefined;
  csrfToken: string | undefined;
  acceptedTerms: boolean;
  signedIn: boolean;
}

const DEFAULT_SERVER_DATA = {
  recaptchaSiteKey: "",
  csrfToken: "",
  acceptedTerms: false,
  signedIn: false,
};

const ServerDataContext = createContext<ServerData>(DEFAULT_SERVER_DATA);

export { ServerDataContext, DEFAULT_SERVER_DATA };
export type { ServerData };
